<template>
  <div v-if="proceeding">
    <div class="clearfix mb-1">
      <div class="float-left sub-title bolder"> {{ title }}</div>
      <div class="float-right text-right">
        <edit-btn-sm v-if="isAdmin || isTeacher" class="mr-1" @click="onTeacherEdit">강사 작성</edit-btn-sm>
        <edit-btn-sm v-if="isStaff" class="mr-1" @click="onManagerEdit">운영 매니저 작성</edit-btn-sm>
        <edit-btn-sm v-if="isStaff" class="mr-1" @click="onChiefEdit">책임 매니저 작성 </edit-btn-sm>
        <delete-btn-sm v-if="isStaff" @click="onDelete">삭제</delete-btn-sm>
      </div>
    </div>
    <mdb-card class="mb-4">
      <mdb-card-body class="p-2"  v-if="proceeding.info">
        <mdb-row>
          <mdb-col md="12"><mdb-input class="my-1" label="회의명" v-model="proceeding.info.name" disabled/></mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="4"><date-picker v-model="proceeding.info.date" label="날짜" /></mdb-col>
          <mdb-col md="2"><mdb-input label="시간" v-model="proceeding.info.time" disabled/></mdb-col>
          <mdb-col md="5"><mdb-input label="회의 장소" v-model="proceeding.info.place" disabled/></mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>

    <p class="title bottom-line"><mdb-icon far icon="comment-alt" />운영 매니저 의견</p>
    <proceeding-comment-view :content="proceeding.manager"/>

    <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 훈련 강사 의견</p>
    <proceeding-comment-view :content="proceeding.teacher"/>

    <p class="title bottom-line"><mdb-icon far icon="comment-alt" />총괄 매니저 의견</p>
    <proceeding-comment-view :content="proceeding.chief"/>

  </div>
</template>
<script>
import { mdbCard, mdbCardHeader, mdbCardBody } from 'mdbvue';

import Proceeding from '@/models/Proceeding'
import ProceedingCommentView from '@/components/comm/proceeding/ProceedingCommentView.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'StaffProceedingViewPage',
  components: { mdbCard, mdbCardBody, ProceedingCommentView },
  props: [],
  data: function () {
    return {
      proceeding: undefined
    }
  },
  computed: {
    ...mapGetters('auth', ['isStaff', 'isAdmin', 'isTeacher']),
    query () { return this.$route.query },
    title () {
      return this.proceeding.subject + (this.proceeding.lectureName ? ' / ' + this.proceeding.lectureName : '')
    }
  },
  methods: {
    async load () {
      const { id, subject, lectureName, lectureCode } = this.$route.query
      if (id === 'new') {
        this.proceeding = this.$Proceeding.create(this.training, subject, lectureName, lectureCode)
      } else {
        this.proceeding = await this.$Proceeding.get(id)
        // console.log(this.proceeding)
      }
      // console.log(this.proceeding)
    },
    onTeacherEdit () {
      const query = {
        ...this.$route.query,
        who: 'TEACHER'
      }
      this.$router.push({ name: 'StaffProceedingEditPage', query })
    },
    onManagerEdit () {
      const query = {
        ...this.$route.query,
        who: 'MANAGER'
      }
      this.$router.push({ name: 'StaffProceedingEditPage', query })
    },
    onChiefEdit () {
      const query = {
        ...this.$route.query,
        who: 'CHIEF'
      }
      this.$router.push({ name: 'StaffProceedingEditPage', query })
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.proceeding.delete()
      this.$router.push({ name: 'StaffProceedingPage' })
    }
  },
  watch: { query: 'load' },
  created () { this.load() }
}
</script>
